var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContract({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3005_13841",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3005_13841)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.375 43.75C9.95 43.75 8.73958 43.2542 7.74375 42.2625C6.74792 41.2708 6.25 40.0667 6.25 38.65V31.875H12V4.25H41.75V38.65C41.75 40.0667 41.2521 41.2708 40.2563 42.2625C39.2604 43.2542 38.05 43.75 36.625 43.75H11.375ZM36.6206 40.875C37.2569 40.875 37.7917 40.6618 38.225 40.2353C38.6583 39.8088 38.875 39.2804 38.875 38.65V7.125H14.875V31.875H34.4V38.6531C34.4 39.2744 34.6128 39.8 35.0385 40.23C35.4641 40.66 35.9914 40.875 36.6206 40.875ZM18 15.75V12.875H35.75V15.75H18ZM18 21.75V18.875H35.75V21.75H18ZM11.335 40.875H31.525V34.75H9.125V38.65C9.125 39.2804 9.34262 39.8088 9.77785 40.2353C10.2131 40.6618 10.7322 40.875 11.335 40.875Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContract);
export default __webpack_public_path__ + "static/media/contract.f091c3d545a733cb962a8259e5247e0c.svg";
export { ForwardRef as ReactComponent };